import { tv } from './chunk-7NOFBOMW.js';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

var textareaStyles = tv({
  base: [
    "border-input placeholder:text-muted-foreground bg-background invalid:border-destructive hover:bg-muted flex min-h-[60px] w-full rounded-lg border px-3 py-2 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50",
    "focus-visible:ring-ring focus:ring-offset-2 focus-visible:outline-none focus-visible:ring-2"
  ],
  variants: {
    invalid: {
      true: "border-destructive"
    }
  },
  defaultVariants: {
    invalid: false
  }
});
var Textarea = forwardRef(
  ({ className, invalid, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      "textarea",
      {
        className: textareaStyles({
          className,
          invalid
        }),
        ref,
        ...props
      }
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea, textareaStyles };
//# sourceMappingURL=chunk-YIPOTJIE.js.map
//# sourceMappingURL=chunk-YIPOTJIE.js.map